<template>
  <div>
    <vs-button
      icon="search"
      type="line"
      size="small"
      @click="openModal()"
      color="#3da4fd"
    >
      <b style="font-size: 16px">Filtrar</b>
    </vs-button>
    <vs-popup
      title="Filtrar"
      :active.sync="open"
      button-close-hidden
      @close="fecharModal"
      class="popup-filtro-contas-receber"
    >
      <div class="w-full relative">
        <!-- Botão customizado de fechar confiável -->
        <div class="custom-filtro-close" @click.stop="fecharModal()" title="Fechar">
          <i class="material-icons" style="font-size: 18px;">close</i>
        </div>
        <vs-row vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="flex-end"
            vs-w="12"
          >
            <vs-input
              color="dark"
              style="width: 460px"
              class="mx-1 inputx w-full"
              type="text"
              placeholder="Ex: Murad Murched"
              size="small"
              label="Cliente"
              v-model="filtro.cliente"
            ></vs-input>
            <vs-input
              color="dark"
              class="mx-1"
              type="text"
              placeholder="00000"
              size="small"
              label="NF"
              v-model="filtro.nf"
            ></vs-input>
          </vs-col>
        </vs-row>
        <div id="filtroSelects" class="vs-con-loading__container">
          <vs-row
            vs-type="flex"
            class="mb-2"
            vs-justify="space-between"
            vs-align="center"
            vs-w="12"
          >
            <vs-col
              vs-type="flex"
              vs-justify="space-between"
              vs-align="flex-end"
              vs-w="12"
            >
              <el-select
                filterable
                clearable
                placeholder="Tipo de Pessoa"
                size="small"
                v-model="filtro.tipo_pessoa"
                class="mx-1 mt-2"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(tipo, index) in tipo_pessoa"
                  :value="tipo.value"
                  :label="tipo.nome"
                  :key="index"
                ></el-option>
              </el-select>
              <el-select
                filterable
                clearable
                size="small"
                placeholder="Forma de Pagamento"
                v-model="filtro.id_forma_pagamento"
                class="mx-1 mt-2"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="formaPagamento in formasPagamento"
                  :value="formaPagamento.id"
                  :label="formaPagamento.nome"
                  :key="formaPagamento.id"
                ></el-option>
              </el-select>
              <el-select
                filterable
                clearable
                size="small"
                placeholder="Empresa"
                v-model="filtro.id_empresa"
                :popper-append-to-body="false"
                class="mx-1 mt-2"
              >
                <el-option
                  v-for="empresa in empresas"
                  :value="empresa.id"
                  :label="empresa.razao_social"
                  :key="empresa.id"
                ></el-option>
              </el-select>
            </vs-col>
          </vs-row>
          <vs-row
            vs-type="flex"
            class="mb-2"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
          >
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="12"
            >
              <el-select
                filterable
                :popper-append-to-body="false"
                clearable
                size="small"
                placeholder="Portadores"
                v-model="filtro.id_portador"
                class="mx-1 mt-2"
              >
                <el-option
                  v-for="portador in portadores"
                  :value="portador.id"
                  :label="portador.nome"
                  :key="portador.id"
                ></el-option>
              </el-select>
              <el-select
                filterable
                clearable
                remote
                :remote-method="filtroPlanoConta"
                loading-text="Buscando..."
                size="small"
                :loading="loading"
                :popper-append-to-body="false"
                placeholder="Plano Conta"
                v-model="filtro.id_plano_conta"
                class="mx-1 mt-2"
              >
                <el-option
                  v-for="data in plano_conta"
                  :value="data.id"
                  :label="data.nome"
                  :key="data.id"
                ></el-option>
              </el-select>
              <el-select
                filterable
                size="small"
                clearable
                name="status"
                placeholder="Status"
                :popper-append-to-body="false"
                v-model="filtro.id_status"
                class="mx-1 mt-2"
              >
                <el-option
                  v-for="data in status"
                  :value="data.id"
                  :label="data.nome"
                  :key="data.id"
                ></el-option>
              </el-select>
              <el-select
                filterable
                size="small"
                clearable
                name="vendedor"
                placeholder="vendedor"
                :popper-append-to-body="false"
                v-model="filtro.id_vendedor"
                class="mx-1 mt-2"
              >
                <el-option
                  v-for="data in vendedores"
                  :value="data.id"
                  :label="data.nome"
                  :key="data.id"
                ></el-option>
              </el-select>
            </vs-col>
          
          </vs-row>
        </div>
        <vs-row
          vs-type="flex"
          class="mt-3 mb-3"
          vs-justify="flex-end"
          vs-align="flex-end"
          vs-w="12"
        >
        <vs-col
            vs-type="flex"
            vs-justify="flex-end"
            vs-align="flex-end"
            vs-w="6"
          >
            <!-- <vs-checkbox color="success" v-model="filtro.num_parcelas_aberto">
              
            </vs-checkbox> -->
            Parcelas em Atraso
          <vs-input
              color="dark"
              type="number"
              placeholder="#"
              size="small"
              class="mx-6"
              v-model="filtro.parcelasEmAtraso"
          ></vs-input>
        </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="flex-end"
            vs-align="flex-end"
            vs-w="2"
            class="mx-6"
            
          >
            <vs-checkbox color="success" v-model="filtro.suspenso">
              Suspenso
            </vs-checkbox>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="flex-end"
            vs-align="flex-end"
            vs-w="2"
          >
            <vs-checkbox color="success" v-model="filtro.negativado">
              Negativado
            </vs-checkbox>
          </vs-col>
         
        </vs-row>
        <vs-row
          vs-type="flex"
          class="mb-2"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
        >
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="flex-end"
            vs-w="12"
          >
            <vs-input
              color="dark"
              class="mx-1"
              style="width: 300px"
              size="small"
              v-currency="$currencyFormatterOptions"
              type="text"
              placeholder="R$ 0,00"
              label="Valor De"
              v-model="filtro.valorDe"
            ></vs-input>
            <vs-input
              color="dark"
              style="width: 300px"
              class="mx-1"
              v-currency="$currencyFormatterOptions"
              type="text"
              size="small"
              placeholder="R$ 0,00"
              label="Valor Até"
              v-model="filtro.valorAte"
            ></vs-input>
          </vs-col>
        </vs-row>
        <vs-row
          vs-type="flex"
          class="mb-2"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
        >
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="flex-end"
            vs-w="12"
          >
            <vs-input
              color="dark"
              class="mx-2"
              size="small"
              type="date"
              style="width: 300px"
              label="Quitacao De"
              v-model="filtro.pagamentoDe"
            ></vs-input>
            <vs-input
              color="dark"
              class="mx-2"
              type="date"
              style="width: 300px"
              label="Quitacao Até"
              size="small"
              v-model="filtro.pagamentoAte"
            ></vs-input>
          </vs-col>
        </vs-row>
        <vs-row
          vs-type="flex"
          class="mb-2"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
        >
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="flex-end"
            vs-w="12"
          >
            <vs-input
              color="dark"
              class="mx-2"
              size="small"
              type="date"
              style="width: 300px"
              label="Vencimento De"
              v-model="filtro.dataDe"
            ></vs-input>
            <vs-input
              color="dark"
              class="mx-2"
              type="date"
              style="width: 300px"
              label="Vencimento Até"
              size="small"
              v-model="filtro.dataAte"
            ></vs-input>
          </vs-col>
        </vs-row>
        <vs-row
          vs-type="flex"
          class="mb-2"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
        >
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="flex-end"
            vs-w="12"
          >
            <vs-input
              color="dark"
              class="mx-2"
              size="small"
              type="date"
              style="width: 300px"
              label="Emissão De"
              v-model="filtro.emissaoDe"
            ></vs-input>
            <vs-input
              color="dark"
              class="mx-2"
              style="width: 300px"
              type="date"
              label="Emissão Até"
              size="small"
              v-model="filtro.emissaoAte"
            ></vs-input>
          </vs-col>
        </vs-row>
        <vs-row
          vs-type="flex"
          class="mb-2"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
        >
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="flex-end"
            vs-w="12"
          >
            <vs-input
              color="dark"
              class="mx-1 w-fulll"
              style="width: 600px"
              type="text"
              label="Observação"
              v-model="filtro.obs"
            ></vs-input>
          </vs-col>
        </vs-row>

        <vs-row vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="flex-end"
            vs-w="4"
          >
            <vs-button
              @click="fecharModal()"
              class="w-full mt-3 mx-1"
              color="dark"
              type="border"
              >Cancelar</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="flex-end"
            vs-w="4"
          >
            <vs-button
              @click="limparCampos()"
              class="w-full mt-3 mx-1"
              color="danger"
              type="relief"
              title="Limpar todos os campos preenchidos no formulário"
              :disabled="!temFiltroPreenchido"
              >Limpar Campos</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="flex-end"
            vs-w="4"
          >
            <vs-button
              @click="Filtrar()"
              class="w-full mt-3 mx-1"
              color="success"
              type="relief"
              :disabled="!temFiltroPreenchido"
              >Filtrar</vs-button
            >
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import components from "@/components/default/exports.js";
export default {
  props: {
    filtroInicial: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tipo_pessoa: [
        { value: 1, nome: "PESSOA FÍSICA" },
        { value: 2, nome: "PESSOA JURÍDICA" }
      ],
      empresas: [],
      portadores: [],
      vendedores: [],
      plano_conta: [],
      formasPagamento: [],
      status: [],
      filtro: {},
      limpar: false,
      open: false,
      loading: false
    };
  },
  watch: {
    filtroInicial: {
      deep: true,
      immediate: true,
      handler(novoFiltro) {
        if (novoFiltro && Object.keys(novoFiltro).length > 0) {
          this.filtro = { ...novoFiltro };
        } else {
          this.filtro = {};
        }
      }
    }
  },
  computed: {
    temFiltroPreenchido() {
      if (!this.filtro) return false;
      const chaves = Object.keys(this.filtro);
      for (let i = 0; i < chaves.length; i++) {
        const k = chaves[i];
        if (k === 'dataHoje') continue;
        const val = this.filtro[k];
        if (val !== undefined && val !== null) {
          if (typeof val === 'string' && val.trim() !== '') {
            return true;
          }
          if (typeof val === 'number') {
            return true;
          }
          if (typeof val === 'boolean' && val === true) {
            return true;
          }
          if (Array.isArray(val) && val.length > 0) {
            return true;
          }
        }
      }
      return false;
    }
  },
  methods: {
    async replaceDots(value) {
      if (value && value.search(",") !== -1) {
        value = value.replace(/\./g, "");
        value = value.replace(/,/g, ".");
      }
      return value;
    },

    fecharModal() {
      this.open = false;
      this.$nextTick(() => {
        const popups = document.querySelectorAll('.popup-filtro-contas-receber');
        for (let i = 0; i < popups.length; i++) {
          if (!this.open && popups[i]) {
            popups[i].style.display = 'none';
          }
        }
      });
    },

    limparCampos() {
      if (!this.temFiltroPreenchido) return;
      this.filtro = {};
      this.limpar = false;
    },

    async Filtrar() {
      if (!this.temFiltroPreenchido) return;
      // Fecha o modal IMEDIATAMENTE antes de iniciar a busca
      this.fecharModal();

      try {
        if (this.filtro && this.filtro.valorDe && typeof this.filtro.valorDe === 'string') {
          this.filtro.valorDe = await this.replaceDots(this.filtro.valorDe);
        }
        if (this.filtro && this.filtro.valorAte && typeof this.filtro.valorAte === 'string') {
          this.filtro.valorAte = await this.replaceDots(this.filtro.valorAte);
        }

        if (this.limpar) {
          this.filtro = {};
          this.limpar = false;
        }

        const filtroLimpo = {};
        if (this.filtro) {
          const chaves = Object.keys(this.filtro);
          for (let i = 0; i < chaves.length; i++) {
            const k = chaves[i];
            const v = this.filtro[k];
            if (v !== undefined && v !== null && v !== '') {
              filtroLimpo[k] = v;
            }
          }
        }

        this.$emit("filtro", filtroLimpo);
      } catch (err) {
        console.error("Erro ao aplicar filtros:", err);
      }
    },
    async getEmpresas() {
      try {
        this.empresas = await this.$http.get(`empresa`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async getFormasPagamento() {
      try {
        this.formasPagamento = await this.$http.get(`formasPagamento`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async getPortadores() {
      try {
        this.portadores = await this.$http.get(`portador`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async getVendedores() {
      try {
        this.vendedores = await this.$http.get(`colaborador`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async getContaStatus() {
      try {
        this.status = await this.$http.get(`conta_status`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async openModal() {
      if (this.filtroInicial && Object.keys(this.filtroInicial).length > 0) {
        this.filtro = { ...this.filtroInicial };
      } else {
        this.filtro = {};
      }
      this.open = true;
      this.$nextTick(() => {
        const popups = document.querySelectorAll('.popup-filtro-contas-receber');
        for (let i = 0; i < popups.length; i++) {
          if (this.open && popups[i]) {
            popups[i].style.display = '';
          }
        }
      });
      this.carregarDadosAuxiliares();
    },
    async carregarDadosAuxiliares() {
      if (this.empresas && this.empresas.length > 0) return;
      try {
        await Promise.all([
          this.getPortadores(),
          this.getEmpresas(),
          this.getVendedores(),
          this.getFormasPagamento(),
          this.getContaStatus()
        ]);
      } catch (err) {
        console.error('Erro ao carregar dados do filtro:', err);
      }
    },
    async getPlanoContaByQuery(query) {
      try {
        this.plano_conta = await this.$http.post(`getPlanoContaByQuery`, {
          query: query
        });
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async filtroPlanoConta(query) {
      if (query.length > 2) {
        this.loading = true;
        try {
          await this.getPlanoContaByQuery(query);
        } catch (err) {
          const error = this.$httpErrors(err);
          this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
        } finally {
          this.loading = false;
        }
      }
    }
  },
  beforeDestroy() {
    const popups = document.querySelectorAll('.popup-filtro-contas-receber');
    for (let i = 0; i < popups.length; i++) {
      const el = popups[i];
      if (el && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  },
  async mounted() {
    this.carregarDadosAuxiliares();
  },
  components: {
    ...components
  }
};
</script>

<style lang="scss">
.popup-filtro-contas-receber {
  .vs-popup--header {
    position: relative;
  }
}

.custom-filtro-close {
  position: absolute;
  top: -46px;
  right: 4px;
  cursor: pointer;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 5px;
  background: #c0564b !important;
  color: #ffffff !important;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.1);
  transform: translate(8px, -8px);
  transition: all 0.23s ease 0.1s;

  &:hover {
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.1);
    transform: translate(5px, -5px);
    opacity: 0.9;
  }
}
</style>
